import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import { projectAuth } from './firebase/config'
import { startDrainer, whenFlagsReady } from '@/sync'
import './assets/tailwind.css'
// PrimeVue v4 uses theme presets (Aura) — no CSS theme imports needed
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";
// FullCalendar v6 bundles CSS in JS — no separate CSS imports needed
import './assets/layout/layout.scss';
import './assets/layout/flags/flags.css';


import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
//Prime Vue Components
import Card from 'primevue/card';
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast'
import FileUpload from 'primevue/fileupload';
import ConfirmPopup from 'primevue/confirmpopup';
import RadioButton from 'primevue/radiobutton';
import InputSwitch from 'primevue/inputswitch';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Select from 'primevue/select';
import Calendar from 'primevue/calendar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import InputMask from 'primevue/inputmask';
import AppTag from '@/components/AppTag.vue';
import Fieldset from 'primevue/fieldset';
import Inplace from 'primevue/inplace';
import ConfirmDialog from 'primevue/confirmdialog';
import Checkbox from 'primevue/checkbox';
// FullCalendar, Chart, ColorPicker — imported locally in views that use them
import ToggleButton from 'primevue/togglebutton';
import MultiSelect from 'primevue/multiselect';




import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';


//Style Global Old Styles
import '../src/assets/main.css'
                          //icons
router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});



const app = createApp(App);
{
        app.use(router)
        app.use(PrimeVue, {
            theme: {
                preset: Aura
            },
            locale: {
                accept: 'Tak',
                reject: 'Nie',
                startsWith: 'Starts with',
                contains: 'Contains',
                notContains: 'Not contains',
                endsWith: 'Ends with',
                equals: 'Equals',
                notEquals: 'Not equals',
                noFilter: 'No Filter',
                lt: 'Less than',
                lte: 'Less than or equal to',
                gt: 'Greater than',
                gte: 'Greater than or equal to',
                dateIs: 'Date is',
                dateIsNot: 'Date is not',
                dateBefore: 'Date is before',
                dateAfter: 'Date is after',
                clear: 'Wyczysc',
                apply: 'Aplikuj',
                matchAll: 'Match All',
                matchAny: 'Match Any',
                addRule: 'Add Rule',
                removeRule: 'Remove Rule',
                choose: 'Choose',
                upload: 'Upload',
                cancel: 'Cancel',
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"],
                monthNames: ["Styczen","Luty","Marzec","April","May","June","July","August","September","October","November","December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                today: 'Dzisiaj',
                weekHeader: 'Wk',
                firstDayOfWeek: 0,
                dateFormat: 'dd/mm/yy',
                weak: 'Weak',
                medium: 'Medium',
                strong: 'Strong',
                passwordPrompt: 'Enter a password',
                emptyFilterMessage: 'No results found',
                emptyMessage: 'No available options'
            }
        });
        // Global config data
        app.config.globalProperties.$globalVariableWojewodztwa  =[
			{name: 'dolnośląskie'},
			{name: 'kujawsko-pomorskie'},
			{name: 'lubelskie'},
			{name: 'lubuskie'},
            {name: 'łódzkie'},
			{name: 'małopolskie'},
            {name: 'mazowieckie'},
            {name: 'opolskie'},
            {name: 'podkarpackie'},
            {name: 'podlaskie'},
            {name: 'pomorskie'},
            {name: 'śląskie'},
            {name: 'świętokrzyskie'},
            {name: 'warmińsko-mazurskie'},
            {name: 'wielkopolskie'},
            {name: 'zachodniopomorskie'},
		]
        app.config.globalProperties.$globalemailOpcje = [
			{name: 'Krzysztof Gola, tel. 695 464 212 (biuro@wiazary-kratowe.pl)', id: 1},
			{name: 'Damian Stępień, tel. 695 464 035 (biuro2@wiazary-kratowe.pl)', id: 2},
            {name: 'Artur Suś, tel. 695 464 699 (biuro2@wiazary-kratowe.pl)', id: 3},
			{name: 'Karolina Raszewska, tel. 695 464 050 (biuro2@wiazary-kratowe.pl)', id: 4},
            {name: 'Jagoda Pływaczyk, tel. 655 464 020 (biuro@wiazary-kratowe.pl)', id: 5},
			{name: 'Jakub Muskała, tel. 695 464 665 (biuro@wiazary-kratowe.pl)', id: 6},
            {name: 'Kinga Zadka, tel. 695 464 020 (biuro@wiazary-kratowe.pl)', id: 7}
		]


        app.config.globalProperties.$globalcenaObejmujeOpcje=[
			{name: 'Projekt', id: 1},
			{name: 'Produkcja', id: 2},
            {name: 'Transport', id: 3},
            {name: 'Montaż', id: 4}
		]


        
        //app.config.globalProperties.$primevue = reactive({ ripple: true});
        //co to jest ?? kszyszko?
        

        app.use(ToastService)
        app.use(ConfirmationService);
        app.component('Dialog', Dialog);
        app.component('DataTable', DataTable);
        app.component('Column', Column);
        app.component('ColumnGroup', ColumnGroup);
        app.component('Button', Button);
        app.component('InputText', InputText);
        app.component('InputNumber', InputNumber);
        app.component('Textarea', Textarea);
        app.component('FileUpload', FileUpload);
        app.component('Toast', Toast);
        app.component('ConfirmPopup', ConfirmPopup);
        app.component('RadioButton', RadioButton);
        app.component('InputSwitch', InputSwitch);
        app.component('Divider', Divider);
        app.component('Card', Card);
        app.component('Dropdown', Dropdown);
        app.component('Select', Select);
        app.component('Calendar',Calendar);
        app.component('Accordion',Accordion);
        app.component('AccordionTab',AccordionTab);
        app.component('InputMask',InputMask);
        app.component('Tag', AppTag);
        app.component('Fieldset',Fieldset);
        app.component('Inplace',Inplace);
        app.component('ConfirmDialog',ConfirmDialog);
        app.component('Checkbox',Checkbox);
        // ColorPicker, Chart, FullCalendar registered locally in their views
        app.component('ToggleButton',ToggleButton);
        app.component('MultiSelect',MultiSelect);
        
    app.mount('#app')

    // Shadow-write subsystem boot (Etap 2+). Both calls are fire-and-forget and
    // must run exactly once at app start:
    //   - whenFlagsReady(): warms the `feature_flags` Firestore listener now, so
    //     the flag cache is hydrated well before the user's first write. Closes
    //     the race where a fast "open app → create offer" dropped the PG mirror
    //     because the flag still read OFF (empty cache).
    //   - startDrainer(): begins the IndexedDB outbox drain loop so writes that
    //     failed their direct POST actually get replayed (it had no call site,
    //     leaving the retry safety-net inert). Idempotent — safe to call once.
    whenFlagsReady();
    startDrainer();
}


